import { useCarePlanService } from '@/shared/guard';
import { Skeleton } from '@/shared/ui';
import { isEmpty } from '@/shared/util';

import { FOOTER_LINKS, HEADER_LINKS } from './nav-menu.constant';
import { NavMenuLink } from './nav-menu-link.component';

export function NavMenu() {
  const { links } = useCarePlanService();

  const headerLinks = links.filter((link) => HEADER_LINKS.includes(link.key));
  const organLinks = links.filter((link) => ![...HEADER_LINKS, ...FOOTER_LINKS].includes(link.key));
  const footerLinks = links.filter((link) => FOOTER_LINKS.includes(link.key));

  return (
    <nav className="bg-fct-background dark:bg-fct-background flex h-full w-55 flex-col overflow-hidden rounded-2xl pt-1 pr-1">
      <div className="custom-scrollbar grid w-full grid-flow-row auto-rows-max grid-cols-none gap-1 overflow-x-hidden overflow-y-auto pb-3">
        <div className="space-y-1">
          {headerLinks.map((link, index) => (
            <NavMenuLink key={link.key} index={index} isSubmenuItem={false} link={link} />
          ))}
        </div>
        {isEmpty(organLinks) ? (
          <div className="mt-2 flex flex-col gap-4 overflow-y-auto px-2">
            <Skeleton className="h-8" count={24} />
          </div>
        ) : (
          <>
            {organLinks.map((link, index) => (
              <NavMenuLink key={link.key} index={index} isSubmenuItem={false} link={link} />
            ))}
          </>
        )}
      </div>
      <div className="border-neutral-850 dark:border-neutral-850 mt-auto space-y-1 border-t py-1">
        {footerLinks.map((link, index) => (
          <NavMenuLink key={link.key} index={index} isSubmenuItem={false} link={link} />
        ))}
      </div>
    </nav>
  );
}
